import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import { CheckIcon } from 'components/ReusableComponents/Icons/Check'
import { CrossIcon } from 'components/ReusableComponents/Icons/Cross'
import LoadingIndicator from 'components/ReusableComponents/LoadingIndicator'
import { useState } from 'react'

import styles from './TryLoginDialog.module.scss'

const TryLoginDialog = ({ isTryingLogin, onClose, response, brand, shortName }) => {
  const isTryLoginSuccessful = response?.isSuccess

  const [isDetailsVisible, setIsDetailsVisible] = useState(false)

  function getError(response) {
    if (response.message.includes('Invalid username or password')) {
      return (
        <div className={styles.problemBad}>
          <p className={styles.title}>Username or password is wrong.</p>
          <p className={styles.description}>
            Solution: We need new credentials from the hotel.
          </p>
        </div>
      )
    } else if (response.message.includes('Password expired')) {
      return (
        <div className={styles.problemBad}>
          <p className={styles.title}>Password expired, but we can set a new password.</p>
          <p className={styles.description}>
            Solution: Contact developers to resolve this issue.
          </p>
        </div>
      )
    } else if (response.message.includes('login successful')) {
      return (
        <div className={styles.problemGood}>
          <p className={styles.title}>Login works just fine.</p>
        </div>
      )
    } else if (response.message.includes('reached all pages')) {
      return (
        <div className={styles.problemGood}>
          <p className={styles.title}>Login works just fine.</p>
        </div>
      )
    } else if (response.message.includes('Reached all pages')) {
      return (
        <div className={styles.problemGood}>
          <p className={styles.title}>Login works just fine.</p>
        </div>
      )
    } else if (response.message.includes('did not reach all pages')) {
      return (
        <div className={styles.problemBad}>
          <p className={styles.title}>
            Login works, but PMS user cannot reach following pages:
          </p>
          <ul className={styles.list}>
            {Object.keys(response.result)
              .filter(k => !response.result[k])
              .map(k => (
                <li key={k}>{k}</li>
              ))}
          </ul>
          <p className={styles.description}>
            Solution: Contact hotel and make get the necessary access for PMS user
          </p>
        </div>
      )
    } else {
      return (
        <>
          <p className={styles.title}>Something went wrong with the login</p>
          <p className={styles.description}>{response.message}</p>
        </>
      )
    }
  }

  return (
    <ConfirmationDialog
      theme="blacklist"
      title={
        isTryingLogin ? (
          'Trying to login...'
        ) : isTryLoginSuccessful ? (
          <>
            <CheckIcon className={styles.titleIcon} /> Login test was successful for{' '}
            {brand} {shortName}
          </>
        ) : (
          <>
            <CrossIcon className={styles.titleIcon} fill="#ff5e5e" /> Login test was
            failed for {brand} {shortName}
          </>
        )
      }
      hasCloseButton={!isTryingLogin}
      hasConfirmButton={!isTryingLogin}
      maxWidth={700}
      onClose={() => onClose()}
    >
      <div className={styles.wrapper}>
        {isTryingLogin && <LoadingIndicator longWaitingTreshold={120} inline={true} />}
        {!isTryingLogin && (
          <div>
            {getError(response)}
            <p
              className={styles.seeDetailsButton}
              onClick={() => setIsDetailsVisible(s => !s)}
            >
              {isDetailsVisible ? 'Hide' : 'See'} details
            </p>
            {isDetailsVisible && (
              <p className={styles.tryLoginResponse}>
                {JSON.stringify(response, null, 4)}
              </p>
            )}
          </div>
        )}
      </div>
    </ConfirmationDialog>
  )
}

export default TryLoginDialog
